// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4953":"366e68ab","6227":"366e68ab","9842":"366e68ab"}[chunkId] + ".chunk.css";
};